import { useEffect, useRef } from 'react';

import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { selectAccountSlug } from '@/redux/session/selectors';
import { CLEAR_DIRTY_VALUES } from '@/util/forms/resetOptions';

export const useResetFormOnAccountSwitch = <T extends FieldValues>(
  form: UseFormReturn<T>,
  fields?: readonly Path<T>[]
) => {
  const slug = useSelector(selectAccountSlug);
  const previousSlug = useRef(slug);

  useEffect(() => {
    if (previousSlug.current === slug) {
      return;
    }
    previousSlug.current = slug;
    if (fields) {
      fields.forEach((field) => form.resetField(field));
      return;
    }
    form.reset(undefined, CLEAR_DIRTY_VALUES);
  }, [fields, form, slug]);
};
